import { Title } from "../../Atoms/Title";
import { Input } from "../../Atoms/Inputs/Input";
import { Button } from "../../Atoms/Button";
import * as S from "./styles";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { useVehicleRegister } from "./useVehicleRegister";

export const VehicleRegisterTemplate = () => {
  const { handleSubmit, isLoad, form, setForm, tipoOptions, tipo, setTipo } =
    useVehicleRegister();

  return (
    <S.Container>
      <Title>Informações do Veículo</Title>

      <S.Form onSubmit={handleSubmit}>
        <S.GridWrapper>
          <div>
            <Input
              required
              label="Modelo do veículo"
              value={form?.modelo ?? ""}
              onChange={(e) => setForm({ ...form, modelo: e?.target?.value })}
            />
          </div>
          <div>
            <Input
              required
              label="Ano"
              value={form?.ano ?? ""}
              onChange={(e) => setForm({ ...form, ano: e?.target?.value })}
            />
          </div>
          <div>
            <Input
              label="Placa"
              value={form?.placa ?? ""}
              onChange={(e) => setForm({ ...form, placa: e?.target?.value })}
            />
          </div>
          <div>
            <Input
              required
              label="Chassi"
              value={form?.chassi ?? ""}
              onChange={(e) => setForm({ ...form, chassi: e?.target?.value })}
            />
          </div>
          <div>
            <SimpleSelect
              required
              label="Tipo de Veículo"
              options={tipoOptions}
              onChange={(e: any) => {
                setTipo(e);
                setForm({ ...form, tipo: e?.code });
              }}
              value={tipo}
            />
          </div>
        </S.GridWrapper>
        <Button disabled={isLoad}>Confirmar</Button>
      </S.Form>
    </S.Container>
  );
};
